/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

/*
 * Public API Surface of ip-email-builder
 */

export * from './lib/interfaces/interfaces';
export * from './lib/tokens/tokens';
// export * from './lib/providers';
export * from './lib/utils';
export * from './lib/classes/DefaultEmail';
export * from './lib/classes/Elements';
export * from './lib/classes/Structure';

export * from './lib/ip-email-builder.service';
export * from './lib/services/user-middleware-service/ip-middlewares.service';
export * from './lib/services/user-rest-api-service/user-rest-api.service';
export * from './lib/services/ip-storage/ip-storage.service';
export { FreeUsersImageUploader } from './lib/services/user-image-uploader-service';
export * from './lib/services/user-image-uploader-service/user-image-uploader.service';

export * from './lib/ip-email-builder.module';

export * from './lib/ip-email-builder.component';
export * from './lib/components/preview.component';
// export * from './lib/components/template-list-dialog/template-list-dialog.component';

export * from './lib/pipes/slugify.pipe';
